module.exports = __webpack_public_path__ + "static/media/southafrica.997ede38.svg";